import { UserRoleAppFormat } from './enum';

export const timeout: number = 60000;

export const gridPageSize: number = 20;

export const colors: string[] = [
  '#ABDEE6',
  '#CBAACB',
  '#FFCCB6',
  '#F3B0C3',
  '#C6DBDA',
  '#FEE1E8',
  '#FED7C3',
  '#ECD5E3',
  '#D4F0F0',
  '#CCE2CB',
  '#FFFFB5',
  '#F6EAC2',
  '#91D8E4'
];

export const errorMessages = {
  ErrorMessageInvalidDataFormat:
    'Invalid data format found in the received response.',
  ErrorMessageGettingLeaveCategories: 'Error in loading leave categories',
  ErrorMessageRequestingLeave: 'Error in requesting the leave',
  ErrorMessageGettingLeaves: 'Error in loading leaves',

  ErrorMessageGettingProfileData: 'Error in loading profile data',

  ErrorMessageFetchAllMembers: 'Error in loading members data',
  ErrorMessageCreatingEmployee: 'Error in creating employee',
  ErrorMessageCreatingLeaves: 'Error in creating leave',
  ErrorMessageCreatingLeavesAlready:
    'Error in creating leave. Already requested leave on date range',

  ErrorMessageGettingLeaveUsers: 'Error in loading Leave Data',
  ErrorMessageInSignIn: 'Error in signing the user.',
  ErrorMessageInSignOut: 'Error in signing out the user.',

  ErrorMessageCommon: 'Something went wrong',

  ErrorAssigningRole: 'Error in assigning user role',

  ErrorMessageForLargeProfilePicture: 'Size of Image should be less than 4mb',
  ErrorMessageForInvalidFileType: 'Image format should be JPEG',

  ErrorMessageGettingNotifications: 'Error in loading notifications',

  ErrorMessageDeletingProject: 'Error in deleting project',

  ErrorMessageCreateUserInProject: 'Error in creating user in project',
  ErrorMessageDeleteUserFromProject: 'Error in deleting user from project',
  ErrorMessageUpdateUserInProject: 'Error in updating user in project',

  ErrorMessageUpdateUserFromProject: 'Error in updating user from project',
  ErrorMessageGettingProjects: 'Error in loading projects',
  ErrormessageCreatingProject: 'Error in Creating a Project',
  ErrormessageEditingProject: 'Error in Editing a Project',

  ErrorMessageDeleteMemberSkill: 'Error in deleting memberSkill',

  ErrorMessageCreatingTools: 'Error in Creating a Tool',
  ErrorMessageEditingTools: 'Error in Editing Tool',
  ErrorMessageDeletingTools: 'Error in Deleting Tool'
};

export const skillLevels = [
  { id: 'INTERMEDIATE', name: 'Intermediate' },
  { id: 'EXPERT', name: 'Expert' }
];

export const validatorsUserRoles = [UserRoleAppFormat.Admin];
